
































































































































// decoradores
import { Component, Emit, Vue } from "vue-property-decorator";
// validaciones
import { email, required } from "vuelidate/lib/validators";
import SVGIcon from "@/components/SVGIcon.vue";
import { firebase } from "@/config/firebase";
// import firebase from "firebase";
import FirebaseError = firebase.FirebaseError;

@Component({
  components: { SVGIcon },
  validations: {
    email: { required, email },
    password: { required },
  },
})
export default class Formulario extends Vue {
  created(): void {
    this.email = "";
    this.password = "";
    this.$store.commit("setErrorLogin", "");
  }

  checkbox = false;
  email = "";
  password = "";
  loading = false;
  registroLogin = 0;
  tipo: "password" | "text" = "password";
  recuperarClave = false;
  invalidEmail = false;
  userNotFound = false;
  userDisabled = false;
  wrongPassword = false;

  get emailErrors(): Array<string> {
    const errors: string[] = [];
    if (!this.$v.email.$dirty) return errors;
    if (!this.$v.email.email) errors.push("Debe ser un correo válido");
    if (!this.$v.email.required) errors.push("Campo requerido");
    if (this.invalidEmail) errors.push("Correo inválido");
    if (this.userNotFound) errors.push("Usuario no encontrado");
    if (this.userDisabled) errors.push("Usuario deshabilitado");
    return errors;
  }

  get passwordErrors(): Array<string> {
    const errors: string[] = [];
    if (!this.$v.password.$dirty) return errors;
    if (!this.$v.password.required) errors.push("Campo requerido");
    if (this.wrongPassword) errors.push("Contraseña incorrecta");
    return errors;
  }

  @Emit("cerrar")
  onCerrar(): void {
    this.recuperarClave = false;
    return;
  }

  @Emit("click-google")
  onClickGoogle(): void {
    return;
  }

  @Emit("click-facebook")
  onClickFacebook(): void {
    return;
  }

  @Emit("open-snackbar")
  onOpenSnackbar(mensaje: { text: string; color: string }): {
    text: string;
    color: string;
  } {
    return mensaje;
  }

  @Emit("terminos")
  onTerminos(): void {
    return;
  }

  @Emit("loginError")
  onLoginError(data: string): string {
    return data;
  }

  resetErrors(): void {
    this.invalidEmail = false;
    this.userNotFound = false;
    this.userDisabled = false;
    this.wrongPassword = false;
  }

  mostrarClave(): void {
    if (this.tipo === "password") {
      this.tipo = "text";
    } else {
      this.tipo = "password";
    }
  }

  async entrar(): Promise<void> {
    this.$v.$touch();
    this.resetErrors();
    this.$store.commit("setErrorLogin", "");
    if (this.$v.$invalid) return;
    this.loading = true;
    try {
      await firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password);
      this.onCerrar();
    } catch (error) {
      const err = error as FirebaseError;
      if (process.env.NODE_ENV !== "production") console.warn(err);
      switch (err.code) {
        case "auth/invalid-email":
          this.invalidEmail = true;
          break;
        case "auth/user-disabled":
          this.userDisabled = true;
          this.onLoginError("inhabilitado");
          break;
        case "auth/user-not-found":
          this.userNotFound = true;
          break;
        case "auth/wrong-password":
        case "auth/invalid-credential":
          this.wrongPassword = true;
          break;
        case "auth/too-many-requests":
          this.onOpenSnackbar({
            text: "Demasiados intentos. Espera unos minutos e intenta de nuevo",
            color: "warning",
          });
          break;
        case "auth/network-request-failed":
          this.onOpenSnackbar({
            text: "Sin conexión. Revisa tu red e intenta de nuevo",
            color: "warning",
          });
          break;
        default:
          this.onOpenSnackbar({
            text: "No se pudo iniciar sesión. Verifica tus datos",
            color: "error",
          });
          break;
      }
      this.$v.$touch();
    } finally {
      this.loading = false;
    }
  }

  async recuperar(): Promise<void> {
    this.$v.email.$touch();
    this.resetErrors();
    this.$store.commit("setErrorLogin", "");
    if (this.$v.email.$invalid) return;
    this.loading = true;
    try {
      await firebase.auth().sendPasswordResetEmail(this.email);
      this.onOpenSnackbar({
        text: "Se ha enviado un correo para recuperar la contraseña",
        color: "success",
      });
    } catch (error) {
      const errorFirebase = error as FirebaseError;
      switch (errorFirebase.code) {
        case "auth/invalid-email":
          this.invalidEmail = true;
          break;
        case "auth/user-not-found":
          this.userNotFound = true;
          break;
      }
      this.$v.email.$touch();
    } finally {
      this.loading = false;
    }
  }
}
